<template>
  <div
    class="wa-link"
    :class="{
      'wa-active': subIsActive(['/parent/home']),
      'wa-cc' : (statusTheme == 'cc') || (statusTheme == 'CC')
    }"
  >
    <div class="wa-link-base"  @click="modalWa = true">
      <!-- Icon WA -->
      <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M57.5 171.667C70 179.167 85 183.333 100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1666 145.833 16.6666 100 16.6666C54.1666 16.6666 16.6666 54.1666 16.6666 100C16.6666 115 20.8333 129.167 27.5 141.667L20.3333 169.217C19.9636 170.639 19.9765 172.134 20.3708 173.549C20.7651 174.965 21.5267 176.251 22.5784 177.277C23.6301 178.304 24.9345 179.034 26.3594 179.393C27.7842 179.753 29.2788 179.729 30.6916 179.325L57.5 171.667Z" stroke="white" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M137.5 123.733C137.5 125.083 137.2 126.475 136.558 127.825C135.904 129.22 135.044 130.509 134.008 131.65C132.167 133.675 130.142 135.133 127.842 136.075C125.592 137.017 123.15 137.5 120.525 137.5C116.692 137.5 112.6 136.6 108.275 134.767C103.703 132.784 99.3695 130.291 95.3583 127.333C90.9957 124.147 86.8786 120.637 83.0417 116.833C79.2455 113.018 75.7438 108.92 72.5667 104.575C69.6469 100.599 67.1762 96.3116 65.2 91.7917C63.4 87.5 62.5 83.4167 62.5 79.525C62.5 76.975 62.95 74.5417 63.85 72.2917C64.75 70 66.1833 67.9 68.175 66.025C70.575 63.6583 73.2 62.5 75.9833 62.5C77.0333 62.5 78.0833 62.725 79.025 63.175C80 63.625 80.8583 64.3 81.5417 65.275L90.2583 77.5417C90.925 78.475 91.425 79.3417 91.7583 80.1667C92.0917 80.95 92.2833 81.7417 92.2833 82.45C92.2725 83.3952 91.9984 84.3187 91.4917 85.1167C90.913 86.0922 90.2068 86.9862 89.3917 87.775L86.5333 90.7417C86.3345 90.9362 86.1785 91.1701 86.0751 91.4284C85.9718 91.6867 85.9235 91.9637 85.9333 92.2417C85.9333 92.5333 85.975 92.8 86.05 93.1C86.1583 93.4 86.275 93.625 86.35 93.85C87.0167 95.0917 88.1833 96.7 89.8417 98.65C91.5333 100.6 93.3333 102.592 95.2833 104.575C97.3167 106.567 99.2667 108.4 101.258 110.092C103.208 111.733 104.825 112.858 106.1 113.533L106.783 113.842C107.083 113.948 107.399 113.999 107.717 113.992C108.004 113.998 108.29 113.944 108.555 113.833C108.821 113.723 109.06 113.558 109.258 113.35L112.108 110.533C113.05 109.6 113.95 108.892 114.817 108.433C115.614 107.925 116.538 107.654 117.483 107.65C118.272 107.662 119.051 107.829 119.775 108.142C120.6 108.475 121.467 108.958 122.4 109.6L134.833 118.417C135.734 119.003 136.451 119.832 136.9 120.808C137.29 121.735 137.493 122.728 137.5 123.733Z" stroke="white" stroke-width="10" stroke-miterlimit="10"/>
      </svg>
    </div>

    <!-- Popup -->
    <div class="modal-wa" :class="modalWa === true ? 'show-popup' : 'hide-popup'">
      <div class="header-wa">
        Contact Us
      </div>

      <div class="container-wa">
        <a
          :href="
            ((statusTheme == 'cc') || (statusTheme == 'CC')) ? 'whatsapp://send?text=Hello&phone=+628111826464'
            : (statusTheme == 'kokoro') || (statusTheme == 'Kokoro') ? 'whatsapp://send?text=Hello&phone=+6285363141701'
            : ''
          "
          target="_blank"
        >
          <div class="content-wa">
            <div class="wa-pict">
              <img src="@/assets/parent/usericon.png" />
            </div>

            <div class="wa-name">
              Admin 1
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Close popup outside -->
    <div class="close-notif" v-if="modalWa === true" @touchstart="modalWa = false" @click="modalWa = false"></div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { onMounted, onUpdated, reactive, ref, computed } from "vue";

  export default {
    name: "Whatsapp Link",

    methods: {
      subIsActive(input) {
        const paths = Array.isArray(input) ? input : [input]
        return paths.some((path) => {
          return this.$route.path.indexOf(path) === 0;
        })
      }
    },

    setup() {
      const modalWa = ref(false)
      const statusTheme = computed(() => {
        return localStorage.getItem('BasicTheme')
      })

      return {
        modalWa,
        statusTheme
      }
    },
  };
</script>
